/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./set-meta.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./set-meta.component";
import * as i3 from "@angular/platform-browser";
var styles_SetMetaComponent = [i0.styles];
var RenderType_SetMetaComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SetMetaComponent, data: {} });
export { RenderType_SetMetaComponent as RenderType_SetMetaComponent };
export function View_SetMetaComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_SetMetaComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-set-meta", [], null, null, null, View_SetMetaComponent_0, RenderType_SetMetaComponent)), i1.ɵdid(1, 114688, null, 0, i2.SetMetaComponent, [i3.Title, i3.Meta], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SetMetaComponentNgFactory = i1.ɵccf("app-set-meta", i2.SetMetaComponent, View_SetMetaComponent_Host_0, { title: "title", seotitle: "seotitle", image: "image", text: "text", seotext: "seotext" }, { updated: "updated" }, []);
export { SetMetaComponentNgFactory as SetMetaComponentNgFactory };
